// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607030904/js/" + chunkId + "." + {"44":"0b25b165","225":"7c318fa6","481":"368c5045","486":"8f38d0d5","770":"200e4bbf"}[chunkId] + ".0.6519239406763926.chunk.js";
};